import { partnerUniversities } from '@/mocks/programData';

export default function Partners() {
  return (
    <section id="parceiros" className="py-20 md:py-28 bg-warm-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <span className="text-accent text-sm font-semibold uppercase tracking-wider">Rede Académica</span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mt-3">
              Instituições Parceiras
            </h2>
            <p className="text-gray-600 mt-4 max-w-xl mx-auto">
              O mestrado é ministrado em parceria entre três universidades angolanas,
              com turmas distribuídas por Luanda, Benguela e Huambo.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {partnerUniversities.map((uni, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-all border border-gray-100"
              >
                <div className="w-20 h-20 rounded-2xl bg-primary/5 flex items-center justify-center mx-auto mb-5">
                  <i className="ri-building-2-line text-primary text-3xl" />
                </div>
                <h3 className="text-lg font-bold text-primary mb-2">{uni.name}</h3>
                <p className="text-accent font-semibold text-sm mb-1">{uni.faculty}</p>
                <div className="flex items-center justify-center gap-2 text-gray-500 text-sm mb-4">
                  <i className="ri-map-pin-line" />
                  {uni.location}
                </div>
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/5 rounded-full">
                  <i className="ri-user-line text-primary text-sm" />
                  <span className="text-primary font-semibold text-sm">{uni.vacancies} vagas</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-white rounded-2xl p-8 border border-gray-100">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center flex-shrink-0">
                <i className="ri-hand-heart-line text-white text-2xl" />
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-lg font-bold text-primary mb-2">Apoio Internacional</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  O Mestrado é subvencionado pela União Europeia, no âmbito do programa UNIAO,
                  e implementado pela agência técnica de cooperação Francesa Expertise France.
                  O projecto de orçamento foi subvencionado no valor de 46.747.390,31 kwanzas
                  (equivalentes a 82.549,39 euros).
                </p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="w-12 h-12 rounded-full bg-blue-900 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">EU</span>
                </div>
                <div className="w-12 h-12 rounded-full bg-blue-700 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">FR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}